import {css} from "@panda/css";

import {Text} from "@pg-design/text-module";

import {IPricesHubDataSource, PRICES_HUB_DATA_SOURCE_COLUMNS} from "../../constants/prices_hub_data_sources";

interface IProps {
    sources: IPricesHubDataSource[];
}

export const PricesHubDataSourcesCards = (props: IProps) => {
    const {sources} = props;

    return (
        <ul className={listStyle}>
            {sources.map((source) => (
                <li key={source.source}>
                    <article className={cardStyle}>
                        <Text as="h3" variant="body_copy_1" className={titleStyle}>
                            {source.source}
                        </Text>

                        <dl className={detailsStyle}>
                            <div className={rowStyle}>
                                <Text as="dt" variant="info_txt_1" className={labelStyle}>
                                    {PRICES_HUB_DATA_SOURCE_COLUMNS.shows}
                                </Text>
                                <Text as="dd" variant="body_copy_2" className={valueStyle}>
                                    {source.shows}
                                </Text>
                            </div>

                            <div className={rowStyle}>
                                <Text as="dt" variant="info_txt_1" className={labelStyle}>
                                    {PRICES_HUB_DATA_SOURCE_COLUMNS.scope}
                                </Text>
                                <Text as="dd" variant="body_copy_2" className={valueStyle}>
                                    {source.scope}
                                </Text>
                            </div>

                            <div className={rowStyle}>
                                <Text as="dt" variant="info_txt_1" className={labelStyle}>
                                    {PRICES_HUB_DATA_SOURCE_COLUMNS.updateFrequency}
                                </Text>
                                <Text as="dd" variant="body_copy_2" className={valueStyle}>
                                    {source.updateFrequency}
                                </Text>
                            </div>
                        </dl>
                    </article>
                </li>
            ))}
        </ul>
    );
};

const listStyle = css({
    display: "flex",
    flexDirection: "column",
    gap: 1.5,
    width: "100%",
    margin: 0,
    padding: 0,
    listStyle: "none"
});

const cardStyle = css({
    display: "flex",
    flexDirection: "column",
    gap: 1.5,
    boxSizing: "border-box",
    height: "100%",
    padding: 2,
    backgroundColor: "var(--colors-white)",
    border: "1px solid var(--colors-gray-400)",
    borderRadius: 1,
    boxShadow: "0 4px 10px 0 rgba(174, 177, 180, 0.3)"
});

const titleStyle = css({
    margin: 0,
    color: "var(--colors-secondary)",
    fontWeight: 500
});

const detailsStyle = css({
    display: "flex",
    flexDirection: "column",
    gap: 1,
    margin: 0
});

const rowStyle = css({
    display: "flex",
    flexDirection: "column",
    gap: "0.2rem"
});

const labelStyle = css({
    color: "var(--colors-gray-700)"
});

const valueStyle = css({
    margin: 0,
    color: "var(--colors-secondary)"
});
import {css} from "@panda/css";

import {Text} from "@pg-design/text-module";

import {IPricesHubDataSource, PRICES_HUB_DATA_SOURCE_COLUMNS} from "../../constants/prices_hub_data_sources";

interface IProps {
    sources: IPricesHubDataSource[];
}

export const PricesHubDataSourcesCards = (props: IProps) => {
    const {sources} = props;

    return (
        <ul className={listStyle}>
            {sources.map((source) => (
                <li key={source.source}>
                    <article className={cardStyle}>
                        <Text as="h3" variant="body_copy_1" className={titleStyle}>
                            {source.source}
                        </Text>

                        <dl className={detailsStyle}>
                            <div className={rowStyle}>
                                <Text as="dt" variant="info_txt_1" className={labelStyle}>
                                    {PRICES_HUB_DATA_SOURCE_COLUMNS.shows}
                                </Text>
                                <Text as="dd" variant="body_copy_2" className={valueStyle}>
                                    {source.shows}
                                </Text>
                            </div>

                            <div className={rowStyle}>
                                <Text as="dt" variant="info_txt_1" className={labelStyle}>
                                    {PRICES_HUB_DATA_SOURCE_COLUMNS.scope}
                                </Text>
                                <Text as="dd" variant="body_copy_2" className={valueStyle}>
                                    {source.scope}
                                </Text>
                            </div>

                            <div className={rowStyle}>
                                <Text as="dt" variant="info_txt_1" className={labelStyle}>
                                    {PRICES_HUB_DATA_SOURCE_COLUMNS.updateFrequency}
                                </Text>
                                <Text as="dd" variant="body_copy_2" className={valueStyle}>
                                    {source.updateFrequency}
                                </Text>
                            </div>
                        </dl>
                    </article>
                </li>
            ))}
        </ul>
    );
};

const listStyle = css({
    display: "flex",
    flexDirection: "column",
    gap: 1.5,
    width: "100%",
    margin: 0,
    padding: 0,
    listStyle: "none"
});

const cardStyle = css({
    display: "flex",
    flexDirection: "column",
    gap: 1.5,
    boxSizing: "border-box",
    height: "100%",
    padding: 2,
    backgroundColor: "var(--colors-white)",
    border: "1px solid var(--colors-gray-400)",
    borderRadius: 1,
    boxShadow: "0 4px 10px 0 rgba(174, 177, 180, 0.3)"
});

const titleStyle = css({
    margin: 0,
    color: "var(--colors-secondary)",
    fontWeight: 500
});

const detailsStyle = css({
    display: "flex",
    flexDirection: "column",
    gap: 1,
    margin: 0
});

const rowStyle = css({
    display: "flex",
    flexDirection: "column",
    gap: "0.2rem"
});

const labelStyle = css({
    color: "var(--colors-gray-700)"
});

const valueStyle = css({
    margin: 0,
    color: "var(--colors-secondary)"
});
